"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    integrations: {
        path: "/settings/data/integrations"
    },
    arcGISExports: {
        path: "/settings/data/integrations/arcgis"
    },
    accela: {
        path: "/settings/data/integrations/accela"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvaW50ZWdyYXRpb25zLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgaW50ZWdyYXRpb25zOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9pbnRlZ3JhdGlvbnNcIixcbiAgfSxcbiAgYXJjR0lTRXhwb3J0czoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvaW50ZWdyYXRpb25zL2FyY2dpc1wiLFxuICB9LFxuICBhY2NlbGE6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9kYXRhL2ludGVncmF0aW9ucy9hY2NlbGFcIixcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwiaW50ZWdyYXRpb25zIiwicGF0aCIsImFyY0dJU0V4cG9ydHMiLCJhY2NlbGEiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxjQUFjO1FBQ1pDLE1BQU07SUFDUjtJQUNBQyxlQUFlO1FBQ2JELE1BQU07SUFDUjtJQUNBRSxRQUFRO1FBQ05GLE1BQU07SUFDUjtBQUNGIn0=